module.exports = __webpack_public_path__ + "img/build1.16f2e1b0.jpeg";